import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { SITE } from "@/lib/site";

const AboutSummary = () => {
    const { t } = useLanguage();
    const T = t.about_summary;
    const stats = t.about.stats;

    return (
        <section
            id="about"
            data-testid="about-summary-section"
            className="py-24 md:py-32 bg-ella-cream relative"
        >
            <div className="ella-container">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    {/* Image */}
                    <div className="lg:col-span-5">
                        <div className="relative">
                            <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-ella-gold/30 to-ella-ink/10 blur-xl opacity-60" />
                            <div className="relative aspect-[4/5] rounded-[1.75rem] overflow-hidden border border-ella-line shadow-[0_24px_60px_rgba(31,29,28,0.12)]">
                                <img
                                    src={SITE.images.consultation}
                                    alt="Mercedes Köstel · Transformation Coach"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="absolute -bottom-6 -right-4 bg-white border border-ella-line rounded-2xl px-5 py-4 shadow-md max-w-[240px]">
                                <p className="ella-overline">{t.about.sign_role}</p>
                                <p className="font-display text-2xl text-ella-ink mt-1.5 leading-none">
                                    {t.about.sign}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Text */}
                    <div className="lg:col-span-7">
                        <span className="ella-overline" data-testid="about-summary-overline">
                            {T.overline}
                        </span>
                        <h2
                            className="ella-headline text-4xl md:text-5xl lg:text-6xl mt-4 text-ella-ink"
                            data-testid="about-summary-title"
                        >
                            {T.title}
                        </h2>

                        <p className="mt-8 text-ella-ink/75 leading-relaxed font-light text-lg">
                            {T.lead}
                        </p>

                        <blockquote className="mt-8 pl-6 border-l-2 border-ella-gold">
                            <p className="ella-overline">{T.highlight_label}</p>
                            <p className="font-serif italic text-xl md:text-2xl text-ella-ink/85 leading-snug mt-2">
                                {T.highlight_body}
                            </p>
                        </blockquote>

                        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5">
                            {stats.map((s, i) => (
                                <div
                                    key={i}
                                    data-testid={`about-summary-stat-${i}`}
                                    className="border-t border-ella-line pt-3"
                                >
                                    <p className="font-display text-2xl md:text-3xl text-ella-ink">
                                        {s.value}
                                    </p>
                                    <p className="ella-overline mt-1.5">{s.label}</p>
                                </div>
                            ))}
                        </div>

                        <Link
                            to="/ueber-mich"
                            data-testid="about-summary-cta"
                            className="inline-flex items-center gap-3 mt-10 group text-ella-ink hover:text-ella-gold-dark transition-colors"
                        >
                            <span className="ella-overline border-b border-ella-ink group-hover:border-ella-gold-dark pb-1 transition-colors">
                                {T.cta}
                            </span>
                            <ArrowRight
                                className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                                strokeWidth={1.5}
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSummary;
